import Image from "next/image";
import { MinProductItemProps } from "./constants";
import PwPProduct from "./PwPProduct";
import { useState } from "react";
import { motion } from "framer-motion";
import { motionVariants } from "../Common/GlobalVars";


interface PwPProps {
  pwp_name: string | null;
  pwp: Array<MinProductItemProps>;
  setSelectProduct: (product: MinProductItemProps) => void;
}

const PwP = (props: PwPProps) => {
  const [show, setShow] = useState(false);

  return (
    <motion.div
      initial="offscreen"
      whileInView="onscreen"
      viewport={{ once: true }}
      variants={motionVariants}
      className="md:mb-20"
    >
      <div className="flex items-start space-x-4 md:items-center">
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/percent.png"}
          alt="percent icon"
          quality={100}
          width={20}
          height={20}
        />
        <p className="text-sm font-bold text-black md:text-lg font-poppins">{props.pwp_name !== null ? props.pwp_name : "Paket Diskon"}</p>
      </div>
      <div className="grid grid-cols-1 gap-6 mt-4 md:grid-cols-3">
        {props.pwp.map((product, index) => (
          <div
            key={index}
            className={`md:block ${show ? "block" : index < 2 ? "block" : "hidden"}`}
          >
            <PwPProduct product={product} setSelectProduct={props.setSelectProduct} />
          </div>
        ))}
      </div>
      <div className={show ? "hidden" : "flex justify-center mt-4 md:hidden"}>
        <button
          className={show ? "hidden" : "py-1 px-5 bg-mooimom rounded-lg text-white text-xs font-poppins font-bold"}
          onClick={() => setShow(!show)}
        >
          Tampilkan Semua
        </button>
      </div>
    </motion.div>
  )
}

export default PwP
